import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadIeFixModule } from '../../typeahead-ie-fix/index';
import { MembersearchCellComponent } from './membersearch-cell.component';


@NgModule({
  declarations: [MembersearchCellComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TypeaheadIeFixModule.forRoot(),
  ],
  exports:[MembersearchCellComponent],
})
export class MembersearchCellModule { }
